import React from 'react';
import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import FieldLabelAndValue from '../../components/FieldLabelAndValue';
import { Guarantor } from '../../types';

const useStyles: any = makeStyles((theme) => ({
  guarantorsContainer: {
    margin: theme.spacing(1.5, 3),
  },
}));

interface Props {
  guarantors: Guarantor[];
}

const GuarantorsList = (props: Props) => {
  const { guarantors } = props;
  const classes = useStyles();

  return (
    <Grid className={classes.guarantorsContainer}>
      <FieldLabelAndValue label='Guarantors' dataTestId='uia-guarantors'>
        {guarantors.map((g: any, k: any) => {
          return <li key={k}>{`${g.firstName} ${g.middleName || ''} ${g.lastName}`}</li>;
        })}
      </FieldLabelAndValue>
    </Grid>
  );
};

export default GuarantorsList;
